
const validate = (values) => {
  const  errors = {};

  
   if (!values.password  ) {
    
      errors.password={
        ar: "يجب ادخال كلمة المرور",
        en: "password is Required"
      }
   } 
 
     
   if ( !values.newPassword ) {
   
      errors.newPassword={
        ar: "يجب ادخال تأكيد كلمة المرور",
        en: "confirm password is Required"
      }
  } 
 if(values.newPassword !== (values.password)){
    errors.newPassword={
      ar: "كلمة المرور غير متطابقة",
      en: "Password Not Match"
    }
   }
  return errors
 
}


export default validate;

